<bl-modal-content #content [title]="'採用データ選択'">
  <div body>
    <table class="table table-bordered">
      <tr>
        <th class="title-hedder"></th>
        <th class="value-hedder">お客様情報</th>
        <th class="value-hedder">登録されている情報</th>
      </tr>
      <tr class="row-large" *ngFor="let item of _tableData; index as i">
        <th>{{item.title}}</th>
        <td>
          <div [class.nodata-input]="item.profileEntryNoValue">
            <bl-radio
              [value]="item.selectValue"
              [label]="item.profileEntryValue"
              [checked]="item.selectValue === PROFILE_SELECT"
              [inline]="true"
              (changeEvent)="onChangeSelectValue(PROFILE_SELECT, i)">
            </bl-radio>
            <div *ngFor="let etcValue of item?.profileEntryEtcValue">
              <span class="etc-profile">{{etcValue}}</span>
            </div>
          </div>
        </td>
        <td>
          <div [class.nodata-input]="item.customerVehicleNoValue">
            <bl-radio
              [value]="item.selectValue"
              [label]="item.customerVehicleValue"
              [checked]="item.selectValue === CUSTOMER_VEHICLE_SELECT"
              [inline]="true"
              [disabled]="item.customerVehicleDisabled"
              (changeEvent)="onChangeSelectValue(CUSTOMER_VEHICLE_SELECT, i)">
            </bl-radio>
            <div *ngFor="let etcValue of item?.customerVehicleEtcValue">
              <span class="etc-value">{{etcValue}}</span>
            </div>
          </div>
        </td>
      </tr>
      <tr class="row-large" *ngIf="!_customerOnly">
        <th>車検証画像<br><span class="small">（車両に関連する画像）</span></th>
        <td>
          <div *ngIf="!_imageProfile">
            <span>・画像は登録されていません。</span>
          </div>
          <div *ngIf="_imageProfile">
            <div class="file-info">
              <div class="check-feild">
                <bl-checkbox
                  [inline]="true"
                  [checked]="_isImageProfileCheck"
                  [disabled]="_isImageProfileCheckDisabled"
                  (changeEvent)="onChangeImageProfile($event.target.checked)"
                ></bl-checkbox>
              </div>
              <share-attachment *ngIf="_imageProfile"
                [fileManageInfos]="[_imageProfile]"
                [readonly]="true"
                [fontSize]="'0px'">
              </share-attachment>
            </div>
            <span class="etc-profile"><br>※登録済みの画像と合わせて2枚まで登録できます。</span>
            <span class="etc-profile"><br>　登録する画像を選択してください。</span>
            <span class="etc-profile" *ngIf="_imageProfile && _isImageProfileCheckDisabled">
              <br>※登録済みの画像と同じ為、選択できません。
            </span>
          </div>
        </td>
        <td>
          <div *ngIf="!_imageVehicleFst">
            <span>・画像は登録されていません。</span>
          </div>
          <div *ngIf="_imageVehicleFst">
            <div class="file-info">
              <div class="check-feild">
                <bl-checkbox
                  [inline]="true"
                  [checked]="_isImageVehicleFstCheck"
                  [disabled]="_isImageVehicleFstCheckDisabled"
                  (changeEvent)="onChangeImageVehicleFst($event.target.checked)"
                ></bl-checkbox>
              </div>
              <share-attachment *ngIf="_imageVehicleFst"
                [fileManageInfos]="[_imageVehicleFst]"
                [readonly]="true"
                [fontSize]="'0px'">
              </share-attachment>
            </div>
            <div class="file-info" *ngIf="_imageVehicleScd">
              <div class="check-feild">
                <bl-checkbox
                  [inline]="true"
                  [checked]="_isImageVehicleScdCheck"
                  [disabled]="_isImageVehicleScdCheckDisabled"
                  (changeEvent)="onChangeImageVehicleScd($event.target.checked)"
                ></bl-checkbox>
              </div>
              <share-attachment *ngIf="_imageVehicleScd"
                [fileManageInfos]="[_imageVehicleScd]"
                [readonly]="true"
                [fontSize]="'0px'">
              </share-attachment>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <th>申し送り事項<br><span class="small">※顧客車両の「メモ」に反映されます</span></th>
        <td colspan="2">
          <div class="item-header">
            <div class="memo-target-group">
              <bl-radio-group
                [groupType]="'inline'"
                [items]="memoTargetDivItemList"
                [value]="_memoTargetDiv"
                [option]="{ labelProperty: 'text', valueProperty: 'value'}"
                (changeEvent)="onChangeMemoTargetDiv($event)"
              >
              </bl-radio-group>
              <div class="u-mg10l">に対するメモ</div>
              <div class="fixed-button">
                <button
                  class="btn btn-default u-mg10l"
                  (click)="onClickShowFixedFormatMemoModal()"
                >定型文</button>
              </div>
            </div>
          </div>
          <bl-textarea
            #memoComp
            [value]="_memo"
            [rows]="3"
            [maxlength]="200"
            (changeEvent)="onChangeMemo($event)"
          ></bl-textarea>
          <bl-checkbox
            [label]="'重要メモに設定する(絞り込み表示対象にする)'"
            [inline]="true"
            [checked]="_displayMemoImportantDiv"
            (changeEvent)="onClickNarrowDown($event.target.checked)"
          ></bl-checkbox>
        </td>
      </tr>
    </table>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/page/profile-entries-page/profile-data-select-modal/profile-data-select-modal.component.html